// extracted by mini-css-extract-plugin
export default {"integrationIconContainer":"IntegrationLinkRow-module__integrationIconContainer--4CT5O","animatedBackground":"IntegrationLinkRow-module__animatedBackground--cT3-n"};